/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentListVo } from './PaymentListVo';
import {
    PaymentListVoFromJSON,
    PaymentListVoFromJSONTyped,
    PaymentListVoToJSON,
    PaymentListVoToJSONTyped,
} from './PaymentListVo';

/**
 * 
 * @export
 * @interface ResponsePaymentListVo
 */
export interface ResponsePaymentListVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePaymentListVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePaymentListVo
     */
    message?: string;
    /**
     * 
     * @type {PaymentListVo}
     * @memberof ResponsePaymentListVo
     */
    data?: PaymentListVo;
}

/**
 * Check if a given object implements the ResponsePaymentListVo interface.
 */
export function instanceOfResponsePaymentListVo(value: object): value is ResponsePaymentListVo {
    return true;
}

export function ResponsePaymentListVoFromJSON(json: any): ResponsePaymentListVo {
    return ResponsePaymentListVoFromJSONTyped(json, false);
}

export function ResponsePaymentListVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePaymentListVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PaymentListVoFromJSON(json['data']),
    };
}

export function ResponsePaymentListVoToJSON(json: any): ResponsePaymentListVo {
    return ResponsePaymentListVoToJSONTyped(json, false);
}

export function ResponsePaymentListVoToJSONTyped(value?: ResponsePaymentListVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PaymentListVoToJSON(value['data']),
    };
}

